if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else if(typeof Shopify.onCartUpdate === 'function'){
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}


$(document).ready(function(){

  // Chrome 1 - 71
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

  // Safari 3.0+ "[object HTMLElementConstructor]"
  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

  if(isSafari) {
    $('.cartDrawer .quick-items').addClass('isSafari');
  }
  if(isChrome) {
    $('.cartDrawer .quick-items').addClass('isChrome');
  }
  if ($(this).scrollTop() > 0) {
    $(".header .scrolled-nav").addClass("scrolled");
  }
  else {
    $(".header .scrolled-nav").removeClass("scrolled");
  }
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 0) {
      $(".header .scrolled-nav").addClass("scrolled");
    }
    else {
      $(".header .scrolled-nav").removeClass("scrolled");
    }
  });

  $('.shopify-currency-form select').on('change', function() {
    $(this).parents('form').submit();
  });

  $('.countrySwitcher1').on('change', function() {
    if($(this).val() == 'US'){
      window.location.href = "https://nourished3.com/?scr=yes";
    }
  });


  if($('.cpt-subscription-additional-html-container').length) {
    var subscription_interval = setInterval(function() {
      if($('.rc_container').length) {
        $('.rc_widget__option--subsave [data-plans-container]').append($('.cpt-subscription-additional-html-container'));
        clearInterval(subscription_interval);
      }
    }, 1000);
  }

  if($('[data-subscription-popup]').length) {
    $(document).on('click', '.cpt-subscription-additional-html-wrapper', function(e){
      $('[data-subscription-popup]').toggleClass('is-visible');
      $('body').toggleClass('modalOpen');
    });

    $(document).on('click', '[data-close-subscription-popup]', function(e){
      $('[data-subscription-popup]').toggleClass('is-visible');
      $('body').toggleClass('modalOpen');
    });

    $(document).on('click', '[data-subscription-popup]', function(e){
  		if(!$(e.target).parents('.custom-modal').length){
  			$('[data-subscription-popup]').toggleClass('is-visible');
  			$('body').toggleClass('modalOpen');
  		}
  	});
  }

  $('.announcement-close').on('click',function(e){
    e.preventDefault();
    $(this).closest('.announcement-bar').remove();
    $('.home-page .main-content').css('margin-top',' 0px');
    $('body').addClass('add_close');
  });
    $('.featured-slider').slick({
        arrows:true,
        dots:false,
        infinite:true,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      $('.review-slider').slick({
        arrows:true,
        dots:false,
        infinite:true,
        slidesToShow: 1
      });
      $('.shop-slider').slick({
        arrows:false,
        dots:true,
        infinite:true,
        slidesToShow: 4
      });
  $('.home-slider-warp').slick({
    infinite: true,
    slidesToShow: 1, // Shows a three slides at a time
    slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
    arrows: false, // Adds arrows to sides of slider
    dots: true, // Adds the dots on the bottom
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 6000,
  });


  $('.announcement-wrper').slick({
    infinite: true,
    slidesToShow: 1, // Shows a three slides at a time
    slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
    arrows: false, // Adds arrows to sides of slider
    dots: false, // Adds the dots on the bottom
    autoplay: true,
    autoplaySpeed: 6000,
  });

    $('.prod-slider-left').slick({
      slidesToShow: 4,
      slidesToScroll: 2,
      arrows: true,
      centerMode: false,
      fade: false,
      vertical:false,
      verticalSwiping:false,
      focusOnSelect: true,
      infinite:true,
      asNavFor: '.prod-slider-right',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical:false,
            arrows: false,
          }
        }
      ]
    });
    $('.prod-slider-right').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.prod-slider-left',
      dots: false,
      centerMode: false,
      adaptiveHeight: true,
      focusOnSelect: true,
      arrows:true
    });

    $('.collection-slider').slick({
      arrows:true,
      dots:false,
      infinite:true,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 992,
          settings:  "unslick"
        }
      ]
    });
    $(".scrolltop-btn").click(function() {
      $("html, body").animate({
          scrollTop: 0
      }, "slow");
      //return false;
    });
    $('.mobile-nav-btn').click(function(){
      $(this).toggleClass('openNav');
      $('body').toggleClass('menuOpen');
    });

      $('.nav-list-item.mega-menu, .nav-list-item.dropdown').click(function(){
        $(this).toggleClass('showNav');
        $(this).find('.sub-nav').slideToggle();
      });

  $('.sub-dropdown-in .sub_plus-icon').click(function(){
    $(this).parent('.sub-dropdown-in').toggleClass('showsubNav');
    $(this).parent().find('.nav_sub_dropdown').slideToggle();
  });
    $('.que-ans h4').click(function(){
      if($(this).hasClass('openFaq')) {
        $(this).removeClass('openFaq');
        $(this).next().slideUp();
      }else{
        $('.que-ans h4').removeClass('openFaq');
        $('.que-ans .ans').slideUp();
        $(this).toggleClass('openFaq');
        $(this).next().slideToggle();
      }
    });

  $('.newsletter-form').on('submit', function(e){
    e.preventDefault();
    var x = true;
    var $resultElement = $(this).parent().find(".subscribe-result1");
    $resultElement.empty();
    $('.err-msg').remove();
    var form = $(this);
    console.log(form);
    var em = form.find('input[name="EMAIL"]');

    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      if($(this).hasClass('subscribepop')){
        em.parent().parent().append('<p class="err-msg">Please enter a valid e-mail.</p>');
      }else{
      em.parent().append('<p class="err-msg" >Please enter a valid e-mail.</p>');
                         x = false;
                         }
                         } else {
                         em.parent().find('.err-msg').remove();
    }

    if(x){
      $.ajax({
        type: "GET",
        url: form.attr("action"),
        data: form.serialize(),
        cache: false,
        dataType: "jsonp",
        jsonp: "c", // trigger MailChimp to return a JSONP response
        contentType: "application/json; charset=utf-8",
        error: function(error){
          // According to jquery docs, this is never called for cross-domain JSONP requests
        },

        success: function(data){
          if (data.result != "success") {
            console.log('im in fail' , data.msg);
            var message = data.msg || "Sorry, we can't reach the server at the moment. Please try again later.";
            $resultElement.css("color", "#000");

            if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
              message = "Your email is already subscribed to our mailing list.";
              $resultElement.css("color", "#000");
              $resultElement.html(message);
            }



          } else {
            console.log('im in pass');
            form[0].reset();
            $resultElement.html("");
            $resultElement.css("color", "#000");
            $resultElement.html("Thank you for signing up! Please check your inbox to confirm your subscription.");
          }
        }
      });
    }
  });
  $('.announcement-text .learn-more').click(function(e){
  	e.preventDefault();
    $('.pop-up').slideDown();
  });
  $('.popup-close').click(function(){
  	$('.pop-up').slideUp();
  });


  // mini cart
  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
	  if(jQuery('[name=currencies]').length) {
       Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
      }
      $('#crt').removeClass('loading');
    });
  }
  function refreshCart(cart) {
    if(cart.item_count > 0 ){
      $('.cart-countn').text(cart.item_count);
    }else {
      $('.cart-countn').text("");
    }
  }

  $('body').on('click','.buttonAddtoCart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      Shopify.getCart(function(cart){
        addToCartSuccess();
        if(!btn.parents('.custom-cart-drawer-upsell-container').length) {
          btn.text('add to cart');
        }
        btn.removeAttr('disabled');
        $.getJSON('/cart.js', function(cart){
          refreshCart(cart);
        });
        $('.productGrid .productItem').removeClass('qvopen');
        $('body').addClass('cartOpen');
        $('.cart_overlay').addClass('active');
        $('.fullPage').addClass('witmenu');
      });
    });

  });

  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart, .cart_overlay', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('cartOpen');
  });
  $('.cart_button').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });

  $('body').on('click', '[data-change-quantity]', function(){
    input = $(this).parents('form').find('[name="quantity"]');
    current_value = parseInt(input.val());
    change = parseInt($(this).data('change-quantity'));
    new_value = current_value + change || 1;
    input.val(new_value);
  });

  $('body').on('click', '.adjust',function(){
    //$('#crt').addClass('loading');
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    input.val(ip);
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      }
    }).done(function( data ) {
      Shopify.getCart(function(cart){
        addToCartSuccess();
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
        });
      });
    });

  });
  $("#crt").on('click', "a.remove_item", function(r){
    //$('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      Shopify.getCart(function(cart){
        $('.itemCount').text(c.item_count);
        if(!c.item_count) {
          $('#crt').empty();
          $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
          $('#crt').removeClass('has-item');
          $('#crt').removeClass('loading');
    	  $.getJSON("/cart.js", function(cart) {
          //Shopify.getCart(function(cart){
            refreshCart(cart);
          });
        } else {
          addToCartSuccess();
        }
      }.bind(this));
    });
    $.getJSON("/cart.js", function(cart) {
      refreshCart(cart);
    });
  });

  $('body').on('click','.top_search_bar',function(e){
    e.preventDefault();
  	$('.main-navigation').find('.search_bar_popup').addClass('active');
  });

  $('body').on('click','.search_bar_popup .close_icon',function(e){
  	e.preventDefault();
    $('.main-navigation').find('.search_bar_popup').removeClass('active');
  });

  $('.tabTitle h6').click(function(){
    $('.tabTitle h6').removeClass('activeTab');
    $(this).addClass('activeTab');
    $('.tabDesc .prod-desc').hide();
    $('.tabDesc #'+$(this).data('tab')).show();
  });

  setTimeout(function(){
    //$('.stamped-summary-actions-newreview').trigger('click');
    $('.stamped-product-reviews_text').show();
  }, 5000);
  //          $('.stamped-product-reviews-badge').click(function(e){
  //           e.preventDefault();
  //           // alert();
  //           $('.stamped-summary-actions-newreview').trigger('click');
  //         });
  $('.stamped-product-reviews_text').on('click', function(e){
    // e.preventDefault();
    //alert();

    $('html,body').animate({
      scrollTop: $("#review-section-product").offset().top - 148 },
                           'slow');
  });
  $('.stamped-summary-actions-newreview').trigger('click');



  $('#myModal').on('shown.bs.modal', function () {
    $('#video1')[0].play();
  })
  $('#myModal').on('hidden.bs.modal', function () {
    $('#video1')[0].pause();
  })

  // Cevoid product page gallery fallback
  if (window.location.href.includes("/products/")) {
  	checkUGCProductPage();
  }

  
  function checkUGCProductPage(){
    let productPageGallery = document.querySelectorAll('.cevoid-section-block');
    let checkGallery = new MutationObserver(()=>{
      let productPageSlider = document.querySelectorAll('.cevoid-section-block .cevoid-grid');
  
      if (productPageSlider.length !== 0){
        if( productPageSlider[0].children.length > 0){
        console.log(productPageSlider[0].children.length);
          productPageGallery[0].classList.add('loaded');
          checkGallery.disconnect();
        }
      }
    });
  
    checkGallery.observe(productPageGallery[0], {subtree:true, childList: true});
  }

  $('.muteunmute').click(function(){
    if( $(this).parent().find('video').prop('muted') ) {
          $(this).parent().find('video').prop('muted', false);
          $(this).hide();
      // or toggle class, style it with a volume icon sprite, change background-position
    } else {
     $(this).parent().find('video').prop('muted', true);
      // $(this).text('Unmute');
    }
  });

    $('.thumbnail-inner .prod-slider-inner').click(function() {
      var at = $(this).attr('data-slick-index');
      setTimeout(function(){
        $('.prod-slider-inner').each(function() {
          if ($(this).hasClass('slick-active')) {}else {
            $(this).find('video').trigger('pause');
            $(this).find('video').prop('muted', true);
          }
        });
      }, 150);
      setTimeout(function(){
        $('.prod-slider-inner.slick-active').find('video').trigger('play');
        $('.slick-active[data-slick-index="'+at+'"]').find('.muteunmute').show();
      }, 250);
    });
  setTimeout(function(){
     $('.slick-initialized .iconplay').css('opacity', '1');    
  }, 750);
  
   $(document).on('click', '#locksmith_email_submit', function() {
      $("#locksmith-email-form").removeClass('locksmith-authorization-failed');
     setTimeout(() => { 
      $('#locksmith_email').parent('p').addClass('lockprelative');
      $('#locksmith_email').parent('p').append('<p class="error-auth-lock">You are not signed up, please use the signup form below to signup.</p>');
     }, 2500);
   });

  $('.rich-text-container a.btn-large.btn-black').click(function(e) {
    var dataklaviyo = $(this).attr('dataklaviyo');
    if (dataklaviyo) {
    e.preventDefault();
    e.stopPropagation();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', dataklaviyo]);
    }
  });
});
 
 $(window).on('load', function () {
      setTimeout(() => { 
        $('#locksmith_email').attr('placeholder', 'Insert your email address here'); 
        $('#locksmith_email').parent('p').addClass('lockprelative');
        $('#locksmith_email').parent('p').append('<p class="error-auth-lock">You are not signed up, please use the signup form below to signup.</p>');
      }, 400);

 });
 